import React, { useCallback, useEffect, useState } from "react";
import { Button, Icon, ModalDialog, TextField, Success, PlainButton, classnames, Tooltip } from "@culturehq/components";

import { useProfile } from "app/context";
import { t, Trans } from "app/utils";

import LanguageSelector from "components/LanguageSelector";
import StoriesSlider from "components/stories/StoriesSlider";

import tagsTypes from "constants/tagsTypes";
import ChqModalDialog from "components/common/ChqModalDialog";
import DisplayStories from "./DisplayStories";
import CopyLink from "./CopyLink";
import StoryFilterBar from "./StoryFilterBar";

// const EMBBED_CODE = "<iframe src=\"https://SUBDOMAIN.culturehq.com/stories?QUERY_PARAMS\" frameborder=\"0\" style=\"width:100%; -ms-overflow-style: none; overflow: -moz-scrollbars-none; height:430px\" allowfullscreen></iframe>";
const EMBBED_SLIDER_CODE = "<div id=\"IDENTIFIER\"></div><script type=\"text/javascript\">+function (c, h, q, z, y) { (y = document.createElement(\"script\")).type = \"text/javascript\"; y.src = \"https://assets.culturehq.com/WIDGET_VERSION\"; y.onload = function () { CHQ(c, h, q, z) }; document.getElementsByTagName(\"head\")[0].appendChild(y); }(\"#IDENTIFIER\", \"BOT_TOKEN\", FILTERS)</script>";

const replaceEmbbededSliderCode = (orgId, filters, widgetVersion) => EMBBED_SLIDER_CODE.replaceAll("IDENTIFIER", `chq_${Date.now()}`).replace("BOT_TOKEN", orgId).replace("WIDGET_VERSION", widgetVersion).replace("FILTERS", JSON.stringify(filters));


const EMBBED_CODE = "<div id=\"IDENTIFIER\"></div><script type=\"text/javascript\">+function (c, h, q, z, y) { (y = document.createElement(\"script\")).type = \"text/javascript\"; y.src = \"https://assets.culturehq.com/widget_trigger_external_1655911511.js\"; y.onload = function () { CHQ(c, h, q, z) }; document.getElementsByTagName(\"head\")[0].appendChild(y); }(\"#IDENTIFIER\", \"BOT_TOKEN\", FILTERS, \"EXTERNAL_ID\")</script>";

const replaceEmbbededCode = (orgId, filters, externalHash) => EMBBED_CODE.replaceAll("IDENTIFIER", `chq_${Date.now()}`).replace("BOT_TOKEN", orgId).replace("FILTERS", JSON.stringify(filters)).replace("EXTERNAL_ID", externalHash);

/*
const replaceEmbbededCode = (botToken, filters) => EMBBED_CODE.replaceAll("IDENTIFIER",
`chq_${Date.now()}`)
.replace("BOT_TOKEN", botToken).replace("FILTERS", JSON.stringify(filters));
*/
/*
const replaceEmbbededCode = (subdomain, filters) => EMBBED_CODE.replaceAll("SUBDOMAIN", subdomain)
.replace("QUERY_PARAMS", filters);
*/

/*
const getQueryString = options => Object.keys(options)
.filter(item => options[item].length > 0).map(key => `${key}=${options[key]}`).join("&");
*/
// interest_ids%5B%5D=948961998&interest_ids%5B%5D=948962012&interest_ids%5
// B%5D=948961820&interest_ids%5B%5D=169552531&page=1

export const queryToOptions = queryString => {
  const { i, d, l, s, cl, cy, p, de, v, u, sp, t, org, co } = queryString;

  return {
    interestIds: i || null,
    companyIds: co || null,
    departmentIds: d || null,
    locationIds: l || null,
    skillIds: s || null,
    clubIds: cl || null,
    classYearIds: cy || null,
    programIds: p || null,
    degreeIds: de || null,
    organizationValueIds: v || null,
    userIds: u || null,
    storyPromptIds: sp || null,
    trendIds: t || null,
    organizationId: org || null
  };
};

export const filtersToQuery = filters => {
  const options = {};
  const categoryMap = {
    [tagsTypes.COMPANIES]: "co",
    [tagsTypes.INTERESTS]: "i",
    [tagsTypes.SKILLS]: "s",
    [tagsTypes.DEPARTMENTS]: "d",
    [tagsTypes.PROFESSIONS]: "d",
    [tagsTypes.LOCATIONS]: "l",
    [tagsTypes.CLUBS]: "cl",
    [tagsTypes.CLASS_YEARS]: "cy",
    [tagsTypes.PROGRAMS]: "p",
    [tagsTypes.DEGREES]: "de",
    [tagsTypes.ORG_VALUES]: "v",
    [tagsTypes.USERS]: "u",
    [tagsTypes.STORY_PROMPTS]: "sp",
    [tagsTypes.STORY_TRENDS]: "t"
  };

  filters.forEach(filter => {
    const key = categoryMap[filter.category];
    if (key) {
      options[key] = options[key] || [];
      options[key].push(filter.value);
    }
  });

  return options;
};

const EmbedStoriesSlider = ({
  botToken, onClose: onCloseMenu, orgName, selectedStories
}) => {
  const { profile } = useProfile();
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const [language, setLanguage] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [embeddableCode, setEmbeddableCode] = useState();
  const [embeddableSliderCode, setEmbeddableSliderCode] = useState();
  const [embbedStories, setEmbbedStories] = useState([]);
  const [externalHash] = useState(`#chq_${Date.now()}`);
  const [widgetVersion] = useState(
    orgName === "activisionblizzard" ? "act_widget_1682098241.js" : "widget_1689030416.js"
  );

  useEffect(
    () => {
      setEmbbedStories(selectedStories);
    }, [selectedStories]
  );

  useEffect(
    () => {
      const query = filtersToQuery(selectedFilters);
      let replacebleQuery = { ...query, org: profile.organization.id };
      if (language) {
        replacebleQuery = { ...replacebleQuery, lang: language };
      }
      setEmbeddableCode(replaceEmbbededCode(
        botToken, replacebleQuery, externalHash
      ));
      setEmbeddableSliderCode(replaceEmbbededSliderCode(
        botToken, replacebleQuery, widgetVersion
      ));
    }, [botToken, language, profile, selectedFilters, externalHash, widgetVersion]
  );

  const onOpen = useCallback(() => setOpen(true), [setOpen]);
  const onClose = useCallback(
    () => {
      setCopied(false);
      setOpen(false);
      setSelectedFilters([]);
      setEmbbedStories(selectedStories);
      if (onCloseMenu) {
        onCloseMenu();
      }
    },
    [onCloseMenu, setCopied, setOpen, selectedStories]
  );

  const onCopy = useCallback(
    () => {
      let selector = "#embeddable_code";
      if (activeTab === 0) {
        selector = "#embeddable_slider_code";
      }
      document.querySelector(selector).select();
      document.execCommand("copy");
      setCopied(true);
    },
    [setCopied, activeTab]
  );

  const handleSelectedTags = (updatedOptions, _) => {
    setSelectedFilters(updatedOptions);
  };

  const handleClearSelectedOptions = () => {
    setSelectedFilters([]);
  };

  const handleSelectLanguage = value => {
    setLanguage(value);
  };

  return (
    <>
      <PlainButton onClick={onOpen}>
        <Icon icon="page" /><Trans>Stories Slider</Trans>
      </PlainButton>
      {open && (
        <ChqModalDialog onClose={onClose} className="EmbedStories">
          <ModalDialog.Heading onClose={onClose}>
            <Trans>Embed Stories in a Carousel Slider</Trans>
          </ModalDialog.Heading>
          <ModalDialog.Body>
            <DisplayStories selectedStories={embbedStories} />
            <hr className="row Separator" />
            <StoryFilterBar
              selectedOptions={selectedFilters}
              handleClearSelectedOptions={handleClearSelectedOptions}
              handleSelectedTags={handleSelectedTags}
            />
            <StoriesSlider
              admin
              language={language}
              orgName={orgName}
              stories={embbedStories}
              queryOptions={queryToOptions(filtersToQuery(selectedFilters))}
            />
            <ul role="tablist" aria-label={t("Embed Stories")} className="nav nav-tabs EmbedStories-Tabs">
              <li role="navigation">
                <span
                  className={classnames({ active: activeTab === 0 })}
                  onClick={() => setActiveTab(0)}
                >
                  <Trans>Display stories carousel</Trans>
                </span>
              </li>
              <li role="navigation">
                <span
                  className={classnames({ active: activeTab === 1 })}
                  onClick={() => setActiveTab(1)}
                >
                  <Trans>Display stories from a click action</Trans>
                </span>
              </li>
            </ul>
            <div className="TipContainer">
              <Icon icon="lightbulb" />
              <div>
                {activeTab === 0 ? (
                  <p>
                    <Trans>
                      <strong>Tip:</strong> Use this to display a responsive stories carousel right
                      on your site based on the tags selected above. Copy the code below and paste
                      it into a code block wherever you want it to display.
                    </Trans>
                  </p>
                ) : (
                  <>
                    <p>
                      <Trans>
                        <strong>Tip:</strong> Use this to display relevant stories in a modal based
                        on a click event from an image, link or button. Copy the code below and
                        paste it into a code block. Then copy the link below and place it anywhere
                        on your page to have those stories appear in a modal.
                      </Trans>
                    </p>
                    <p>
                      <Trans>For example:</Trans>
                    </p>
                    <p>
                      <code>{`<a href="${externalHash}">{{ YOUR IMAGE, TEXT, BUTTON GOES HERE! }}</a>`}</code>
                    </p>
                  </>
                )}
              </div>
            </div>
            {activeTab === 0 ? (
              <TextField
                readOnly
                rows={3}
                name="embeddable_slider_code"
                value={embeddableSliderCode}
              />
            ) : (
              <TextField
                readOnly
                rows={3}
                name="embeddable_code"
                value={embeddableCode}
              />
            )}
            {copied && (
              <Success>
                <Trans>Embeddable code copied to the clipboard.</Trans>
              </Success>
            )}
            <div className="ButtonContainer">
              <div className="LanguageSelector">
                <LanguageSelector onSelectLanguage={handleSelectLanguage} />
                <Tooltip tip={t("Any language you select will be the new default subtitle shown as long as it was created.")}>
                  <Icon icon="info" />
                </Tooltip>
              </div>
              {activeTab === 1 && <CopyLink copyText="Below is the hash that you have to use as a link." link={externalHash} hash />}
              <Button primary onClick={onCopy}>
                <Icon icon="copy" />
                <Trans>Copy Code</Trans>
              </Button>
            </div>
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
    </>
  );
};

export default EmbedStoriesSlider;
